import { cva, type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import mergeClasses, { cn } from '@/shared/lib/utils';
const inputVariants = cva('px-3 py-2 placeholder:text-muted-foreground/30 disabled:cursor-not-allowed  transition-colors duration-200 ease-in-out', {
  variants: {
    variant: {
      default: 'flex w-full rounded-lg border text-body3 border-input-border bg-input-background enabled:hover:border-primary disabled:text-foreground/50 disabled:border-input-muted disabled:bg-input-background/60 focus-visible:border-primary  file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/20',
      ghost: 'border-b-2 border-input bg-background focus-visible:outline-none disabled:opacity-50'
    },
    inputSize: {
      default: 'h-10',
      sm: 'h-8'
    }
  },
  defaultVariants: {
    variant: 'default',
    inputSize: 'default'
  }
});
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement>, VariantProps<typeof inputVariants> {
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  noIcon?: boolean;
}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  variant,
  inputSize,
  startIcon,
  endIcon,
  type,
  noIcon,
  ...props
}, ref) => {
  return <div className={cn('', !noIcon && 'relative w-full')}>
        {startIcon && <div className="absolute left-1.5 top-1/2 -translate-y-1/2">
            {startIcon}
          </div>}
        <input type={type} className={mergeClasses(inputVariants({
      variant,
      inputSize
    }), startIcon ? 'pl-9' : '', endIcon ? 'pr-9' : '', className)} ref={ref} {...props} />
        {endIcon && <div className="absolute right-3 top-1/2 flex -translate-y-1/2 items-center justify-center gap-1">
            {endIcon}
          </div>}
      </div>;
});
Input.displayName = 'Input';
export { Input };